import { useContext } from 'react'
import { mainTheme } from 'themes'
import { getValue } from 'firebase-utils'
import { useAccountSecurityContext, UserContext } from 'providers'
import { redirectLogin } from 'phonecom'
/**
 *
 */
export const getRemoteValue = (key) => {
    let remoteMFAValue = getValue('MFA') || {}
    if (remoteMFAValue && typeof remoteMFAValue === 'string') remoteMFAValue = JSON.parse(remoteMFAValue) || {}
    return remoteMFAValue[key] || {}
}

/**
 *
 */
export const useRemindAccountSecurity = () => {
    const user = useContext(UserContext)
    const { client, passwordSecurityState } = useAccountSecurityContext()

    const isNonAdmin = user?.role === 'extension'
    if (!client?._sessionToken) return { }

    const { daysRemainedForPasswordExpiry, hasPasswordExpired, isMfaEnabled, mfaEnableLastDate } = passwordSecurityState.data

    const remindMFA = () => {
        if (isNonAdmin) return false

        if ([undefined, null, true].includes(isMfaEnabled)) return false

        if (mfaEnableLastDate < new Date().toISOString()) return redirectLogin()

        if (mfaEnableLastDate >= new Date().toISOString()) return true

        return false
    }

    const remindPasswordExpiry = () => {
        if (hasPasswordExpired) return redirectLogin()

        if (!daysRemainedForPasswordExpiry) return false

        if (daysRemainedForPasswordExpiry <= 5) return true
        if (daysRemainedForPasswordExpiry <= 10 && daysRemainedForPasswordExpiry > 5) return true
        if (daysRemainedForPasswordExpiry <= 15 && daysRemainedForPasswordExpiry > 10) return true

        return false
    }

    return { remindMFA: remindMFA(), remindPasswordExpiry: remindPasswordExpiry() }
}

/**
 *
 */
export const getMuiTheme = () => {
    const labelInBorderStyle = {
        '& .label-in-border': {
            fontFamily: 'NTR !important',
            color: `${mainTheme.palette.secondary['0']} !important`,
            fontSize: '12px !important',
            lineHeight: '12px !important',
            letterSpacing: '0.2px !important',
            textTransform: 'uppercase !important',
            top: '10px !important',
            transform: 'none !important',
            fontWeight: '500 !important',
            '-webkit-text-stroke-width': '0.3px !important',
            marginLeft: 0
        }
    }
    return {
        '& .foundations-common-input': {
            '& input, & select, & .select, & textarea': {
                boxShadow: 'none !important',
                cursor: 'pointer',
                borderRadius: 0,
                border: 0,
                borderBottom: `1px solid ${mainTheme.palette.secondary['-100']}`,
                padding: '24px 8px 7px 12px',
                background: '#F4F5F6',
                '&:hover': {
                    backgroundColor: mainTheme.palette.secondary['-500'],
                    borderColor: mainTheme.palette.primary['0']
                },
                '&:focus': {
                    borderWidth: '2px',
                    borderColor: mainTheme.palette.primary['0'],
                    cursor: 'text',
                    backgroundColor: `${mainTheme.palette.primary['-500']} !important`,
                    paddingBottom: '6px !important'
                },
                '&:active': {
                    backgroundColor: `${mainTheme.palette.primary['-500']} !important`
                }
            }
        },
        '& .input-wrapper': {
            '&.large': {
                height: '50px'
            },
            '& .label-in-border': {
                maxWidth: '80% !important',
                overflow: 'hidden !important',
                textOverflow: 'ellipsis !important',
                whiteSpace: 'nowrap !important',
                color: '#8c98a0',
                fontFamily: 'Montserrat-medium !important',
                fontSize: '14px !important',
                fontWeight: '500 !important',
                letterSpacing: '-0.1px !important',
                lineHeight: '24px !important',
                height: '24px !important',
                position: 'absolute !important',
                // left: '15px !important',
                left: '10px !important',
                top: 'calc(50% + 3px) !important',
                transform: 'translateY(-50%) !important',
                transition: 'left .2s, top .2s !important',
                backgroundColor: 'transparent !important',
                zIndex: 0,
                cursor: 'text'
            },
            '&:focus-within': {
                ...labelInBorderStyle,
                cursor: 'auto'

            }
        },
        '& .foundations-common-input--has-value.foundations-common-input .input-wrapper': {
            ...labelInBorderStyle,
            cursor: 'auto'

        }
    }
}
